import z from "zod";

export const groupOperators = ["any", "all", "none"] as const;

export const GroupOperator = z.enum(groupOperators);

export type GroupOperator = z.infer<typeof GroupOperator>;
